import { useMediaQuery } from '@mui/material';

import { useIsMobile } from './useIsMobile';

/**
 * Is this a phone, as the new chrome means it?
 *
 * The toggle at the bottom of the screen, the round buttons beside the thumb
 * and the header's Saved pill are a *device's* layout, not a width's: a desktop
 * browser narrowed to 500px keeps the toggle at the top, because a pill pinned
 * to the bottom of a window is nothing but a pill in the way (Sam, Sept 19).
 *
 * So this is the one hook that asks about the device, and it asks the live
 * media query rather than `useIsPhone`, which sniffs the user agent once at
 * startup and stays there. `useIsPhone` keeps its one job: the one-time notice.
 *
 * Width *and* touch, so a tablet and a landscape phone fall to the layout below
 * 900px with the toggle at the top of the header. That is planning's call, and
 * it is this line: drop `useIsMobile()` and every touch screen under 900px gets
 * the phone chrome instead.
 *
 * Everything else in the app stays width-based. This is only for the chrome the
 * Sept 19 references draw.
 */
export function usePhoneChrome(): boolean {
  const narrow = useIsMobile();
  const touchFirst = useMediaQuery('(hover: none) and (pointer: coarse)');
  return narrow && touchFirst;
}
